import { useRouter } from 'next/router';
import cfrConfig from '@creditflowresearch/config';
import cfrUrl from '@/creditflowresearch/infrastructure/url';
import usersUrl from '@users/url';
import useLoginUrlWithConsent from '@framework/cookie-consent/useLoginUrlWithConsent';

const useGetLoginUrl = () => {
  const router = useRouter();

  return useLoginUrlWithConsent(() => {
    const callbackUrl = cfrUrl.getPropagateCallbackUrl(router.asPath);
    return usersUrl.getLoginUrl(callbackUrl, cfrConfig.code);
  });
};

export default useGetLoginUrl;
